<template>
	<el-scrollbar height="270px" class="earlywarning">
		<div class="earlywarning_for">
			<div class="for_nav background-image_lightheight" v-for="item in earning" :key="item.id">
				<el-row>
					<el-col :span="6">
						<div class="for_nav_type">
							{{item.warningType}}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="for_nav_text">
							{{item.warningContent}}
						</div>
						<div class="for_nav_datetimer">
							{{item.warningDateTime}}
						</div>
					</el-col>
					<el-col :span="10">
						<div class="for_nav_setting" :style="item.isResolved==true?'color:#55ff7f;':'color:#ff0000;'">
							<span>{{item.isResolved==true?item.resolvedPeople:'未处理'}}</span>
							<br>
							{{item.resolvedDateTime}}
							<el-button @click="UpdateResolved(item.id)" v-if="!item.isResolved" type="warning"
								link>添加处理人</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>

	</el-scrollbar>
	<el-dialog v-model="UpdateResolveds" title="添加处理人" width="500" align-center>
		<el-input placeholder="姓名" v-model="Resolveds" autocomplete="off" />
		<template #footer>
			<div class="dialog-footer">
				<el-button @click="UpdateResolveds = false">取消</el-button>
				<el-button type="primary" @click="ConfirmUpdateResolved()">
					确认
				</el-button>
			</div>
		</template>
	</el-dialog>

</template>

<script setup>
	import {
		ref,
		onMounted,
		reactive
	} from 'vue';
	import {
		GetWarningtables,
		UpdateResolvedPeople
	} from '@/api/api.js'
	let earning = ref()
	//处理人
	let Resolveds = ref('')
	//dialog关闭
	let UpdateResolveds = ref(false)
	GetWarningtables(1).then(res => {
		earning.value = res.data
	}).catch(err => {
		console.log(err)
	})
	setInterval(() => {
		GetWarningtables(1).then(res => {
			earning.value = res.data
		}).catch(err => {
			console.log(err)
		})
	}, 15000)
	let id = null;

	function UpdateResolved(ids) {
		id = ids
		UpdateResolveds.value=true
	}
	function ConfirmUpdateResolved(){
		console.log(Resolveds.value)
		UpdateResolvedPeople(id,Resolveds.value).then(res => {
			GetWarningtables(1).then(res => {
				earning.value = res.data
			}).catch(err => {
				console.log(err)
			})
		}).catch(err => {
			console.log(err)
		})
		UpdateResolveds.value=false
	}
</script>

<style lang="scss">
	.earlywarning {
		width: 100%;
		height: 280px;
		font-size: 13px;
	}
	.el-scrollbar {
	    --el-scrollbar-opacity: 0.9 !important;
	    --el-scrollbar-bg-color: #34e2b7 !important; 
	}

	.background-image_lightheight {
		background-image: url('../../../assets/home/earlywarning/lightheight.png');
	}

	.background-image_light {
		background-image: url('../../../assets/home/earlywarning/light.png');
	}

	.for_nav {
		height: 50px;
		margin-top: 10px;

		.for_nav_type {
			background-color: #007a77;
			width: 70px;
			line-height: 20px;
			margin-top: 15px;
			height: 20px;
			text-align: center;
			color: aquamarine;
			border-radius: 10px;
		}

		.for_nav_text {
			height: 25px;
			line-height: 25px;
		}

		.for_nav_datetimer {
			height: 25px;
			color: #6ca8a5;
			line-height: 25px;
		}

		.for_nav_setting {
			height: 20px;
			line-height: 20px;
			text-align: center;
			padding-top: 3px;
			padding-left: -20px;
			color: #55ff7f;
		}
	}

	.for_nav :first {
		margin-top: 0px;
	}
</style>